// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1-DBS","title":"Images90_title__22Xjm","images":"Images90_images__1URYt"};